import { apiUrls } from 'constants/apiUrls';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import React, { useEffect, useState } from 'react';
import { Button, InputGroup } from 'react-bootstrap';
import { BiRefresh } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { customerService } from 'services/customerService';

const CustomerDropdown = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState();

    useEffect(() => {
        getCustomers();
    }, []);

    const getCustomers = () => {
        customerService.getAllCustomers(apiUrls.getAllCustomers()).then(res => {
            setCustomers(res);
        });
    }

    const handleChange = (selectedOption) => {
        if (selectedOption && selectedOption.value > 0) {
            navigate(appRoutesUrls.customerView(selectedOption.value));
        }
    }

    return (
        <div style={{ marginLeft: '25px' }}>
            <InputGroup size="md">
                <Select
                    name="customer"
                    options={customers}
                    isSearchable={true}
                    isClearable={true}
                    onChange={handleChange}
                    className="react-select"
                />
                <Button
                    size='sm'
                    type="submit"
                    variant="info"
                    style={{ borderColor: 'hsl(0, 0%, 80%)' }}
                    onClick={() => getCustomers()}>
                    <BiRefresh size={24} />
                </Button>
            </InputGroup>
        </div>
    )
}

export default CustomerDropdown;